"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTopAreaBanners = exports.shouldSkipTopAreaBannersFetch = void 0;
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _i18n = require("@ori/i18n");
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _constants = require("../constants");
var _net = require("../models/graphql-types/net");
var _mapTopAreaBanners = require("../utils/mapTopAreaBanners");
/* istanbul ignore file -- api file */

const shouldSkipTopAreaBannersFetch = ({
  enableTopAreaBanner,
  loadingSegmentationData,
  orderOnBehalfVisible,
  bannerType
}) => loadingSegmentationData || orderOnBehalfVisible || !enableTopAreaBanner || bannerType === null;
exports.shouldSkipTopAreaBannersFetch = shouldSkipTopAreaBannersFetch;
const useGetTopAreaBanners = ({
  bannerType,
  orderOnBehalfVisible
}) => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    loading: loadingSegmentationData,
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    isValidating: loading,
    error: apiError,
    data
  } = (0, _staticApiClientReact.useGetTenantApplicationsBannerEnrichedPermanentTopAreaBanners)(tenant, {
    bannerType: bannerType ?? _net.PermanentTopBannerType.PublicPage,
    customerTypeId: customerTypeId ?? undefined,
    lang: language
  }, {
    swr: {
      enabled: !shouldSkipTopAreaBannersFetch({
        enableTopAreaBanner: isFeatureEnabled(_constants.TopAreaFeature.EnableTopAreaBanner),
        loadingSegmentationData,
        orderOnBehalfVisible,
        bannerType
      }),
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false
    }
  });
  return {
    bannersData: data && bannerType !== null ? (0, _mapTopAreaBanners.mapTopAreaBanners)({
      data: data.data
    }) : undefined,
    error: apiError,
    loading
  };
};
exports.useGetTopAreaBanners = useGetTopAreaBanners;